import { render, staticRenderFns } from "./instead-auth.vue?vue&type=template&id=230aed5a&scoped=true&"
import script from "./instead-auth.vue?vue&type=script&lang=js&"
export * from "./instead-auth.vue?vue&type=script&lang=js&"
import style0 from "./instead-auth.vue?vue&type=style&index=0&id=230aed5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230aed5a",
  null
  
)

export default component.exports